import cx from 'classnames';
import type { FunctionComponent, PropsWithChildren } from 'react';

import { LazyOrganizationDetails } from 'app/src/components/TeamProfile';

import styles from './WorkspacePage.less';

interface WorkspacePageProps {
  fullWidth?: boolean;
  orgId: string;
  isOrgAdmin?: boolean;
}

export const WorkspacePage: FunctionComponent<
  PropsWithChildren<WorkspacePageProps>
> = ({ fullWidth, orgId, isOrgAdmin, children }) => {
  return (
    <div>
      <LazyOrganizationDetails orgId={orgId} isOrgAdmin={isOrgAdmin} />
      <hr role="presentation" className={styles.horizontalRule} />
      <main className={styles.mainColumn}>
        <div
          className={cx(styles.mainColumnInner, {
            [styles.fullWidth]: fullWidth,
          })}
        >
          {children}
        </div>
      </main>
    </div>
  );
};
